import styled from 'styled-components'
import { AgreedForm } from 'primsell-shared-layer/components'

export const StyledAgreedForm = styled(AgreedForm)`
  margin: 24px 0;
`
